import { HostedFormRoot } from "components/hosted-form/hosted-form-root";
import { createBrowserHistory } from "history";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { store } from "store/state";
import { configureErrorTracking } from "./util/error-tracking";

configureErrorTracking();

export const history = createBrowserHistory();

function render(): void {
    const rootElement = document.getElementById("root");
    const root = ReactDOM.createRoot(rootElement);
    root.render(<HostedFormRoot store={store} history={history} />);
}

render();
